import { ALL_CAMP_ACTIVITY } from "../../constant/ActionType";

export default function CampaignAllActivitiesRedc(
    state = {
        campaignAllActivities: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_CAMP_ACTIVITY:
            return {
                ...state,
                campaignAllActivities: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
